import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import query from "jquery";
import { Link, NavLink, useLocation } from "react-router-dom";
import { getCategories, getSubCategories } from "../../features/products/api";
import { getAllCollections } from "../../features/collections/api";
import Logo from "../../assets/images/logo/bigmall-logo.png";
import { useCart } from "../../features/cart/context/CartContext";
import { AuthContext } from "../../features/auth/context/AuthContext";
import { useWishlist } from "../../features/wishlist/context/WishlistContext";
import "../styles/dropdown.css";
import AppDownloadModal from "./AppDownloadModal";
import MobileBanner from "./MobileBanner";
import MobileBottomNav from "./MobileBottomNav";
import "../styles/suggestions-dropdown.css";
import { getSearchedKeywords } from "../../features/products/api";
import CategoryThumb from "../../features/products/components/CategoryThumb";

// Splits a suggestion into parts, marking the ones that match the typed text (safe for any characters).
const highlightMatch = (text, term) => {
  if (!term.trim()) return [{ part: text, match: false }];
  const escaped = term.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return text
    .split(new RegExp(`(${escaped})`, "gi"))
    .filter(Boolean)
    .map((part) => ({ part, match: part.toLowerCase() === term.trim().toLowerCase() }));
};

const Header = () => {
  const { isAuthenticated, logout, user } = useContext(AuthContext);
  const [scroll, setScroll] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { cartCount } = useCart();
  const { wishlistCount } = useWishlist();
  const [collections, setCollections] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const containerRef = useRef(null);
  const [keywords, setKeywords] = useState([]);
  const location = useLocation();

  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = event.target.search.value.trim();
    if (query) {
      setSearchQuery(query);
      navigate(`/search?query=${encodeURIComponent(query)}`);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

useEffect(() => {
  const fetchKeywords = async () => {
    if (!searchQuery.trim()) {
      setKeywords([]);
      return;
    }
      try {
        const data = await getSearchedKeywords(searchQuery);
        setKeywords(Array.isArray(data) ? data : []);

      } catch (error) {
        console.error("Error fetching searched keywords:", error);
      }
  };

  const debounceTimer = setTimeout(fetchKeywords, 300);
  return () => clearTimeout(debounceTimer);
}, [searchQuery]);
  
  const handleSearchSubmitMobile = (event) => {
    event.preventDefault();
    const query = event.target.search.value.trim();
    if (query) {
      setSearchQuery(query);
      navigate(`/search?query=${encodeURIComponent(query)}`);
      handleSearchToggle();
    }
  };
  const fetchCategories = async () => {
    try {
      const data = await getCategories();
      setCategories(data.content);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCollections = async () => {
    const data = await getAllCollections();
    setCollections(data.content);
  };

  useEffect(() => {
    fetchCategories();
    fetchCollections();
  }, []);
  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const q = params.get("query");
  if (q) {
    setSearchQuery(q);
  }
}, [location.search]);

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // Mobile search screen: focus the field, close on Escape, keep the page behind from scrolling.
  const mobileSearchInputRef = useRef(null);
  useEffect(() => {
    if (!activeSearch) return undefined;
    mobileSearchInputRef.current?.focus();
    const handleKey = (event) => {
      if (event.key === "Escape") setActiveSearch(false);
    };
    document.addEventListener("keydown", handleKey);
    document.body.classList.add("ui-modal-open");
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.classList.remove("ui-modal-open");
    };
  }, [activeSearch]);

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);

  // Mobile drawers (menu, categories): close together, on navigation, and keep
  // the page from scrolling behind them.
  const closeDrawers = () => {
    setMenuActive(false);
    setActiveCategory(false);
    setActiveIndexCat(null);
  };
  useEffect(() => {
    setMenuActive(false);
    setActiveCategory(false);
  }, [location.pathname, location.search]);
  useEffect(() => {
    document.body.classList.toggle("mobile-drawer-open", menuActive || activeCategory);
    return () => document.body.classList.remove("mobile-drawer-open");
  }, [menuActive, activeCategory]);

  // Category rows open their subcategories on click; clicking again closes them.
  const latestSubCategoryRequest = useRef(null);
  const toggleCategoryRow = async (index, categoryId) => {
    if (activeIndexCat === index) {
      setActiveIndexCat(null);
      return;
    }
    setActiveIndexCat(index);
    setSubCategories([]);
    latestSubCategoryRequest.current = categoryId;
    setLoading(true);
    try {
      const data = await getSubCategories(categoryId);
      if (latestSubCategoryRequest.current === categoryId) setSubCategories(data);
    } catch (error) {
      console.error("Error fetching sub categories:", error);
    } finally {
      if (latestSubCategoryRequest.current === categoryId) setLoading(false);
    }
  };

  // The category being browsed (/products?category=…&sub=…), highlighted in the menu.
  const browsing = location.pathname === "/products" ? new URLSearchParams(location.search) : null;
  const currentCategoryId = browsing?.get("category");
  const currentSubId = browsing?.get("sub");

  // The category menu closes on a click outside it or on Escape.
  const categoryMenuRef = useRef(null);

  // Opening the menu expands the category being browsed and scrolls it into view.
  useEffect(() => {
    if (!activeCategory || !currentCategoryId) return;
    const index = categories.findIndex((category) => category.id === currentCategoryId);
    if (index < 0) return;
    if (activeIndexCat !== index) toggleCategoryRow(index, currentCategoryId);
    requestAnimationFrame(() => {
      categoryMenuRef.current
        ?.querySelector(`[data-category-id="${currentCategoryId}"]`)
        ?.scrollIntoView({ block: "start" });
    });
    // Only when the menu opens or the categories arrive, not on every row toggle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory, currentCategoryId, categories]);
  useEffect(() => {
    if (!activeCategory) return;
    const onPointerDown = (event) => {
      if (categoryMenuRef.current && !categoryMenuRef.current.contains(event.target)) {
        closeDrawers();
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") closeDrawers();
    };
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [activeCategory]);

  const hasCollections = collections && collections.length > 0;

  const PageTypeCollection = collections?.filter(
    (collection) => collection.type && collection.type === "Page"
  ) || [];

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
        onClick={closeDrawers}
        aria-hidden="true"
      />

 {/* ==================== Search Box Start Here ==================== */}

      <form
        className={`mobile-search d-lg-none${activeSearch ? " is-open" : ""}`}
        onSubmit={handleSearchSubmitMobile}
        role="search"
        aria-hidden={!activeSearch}
      >
        <div className="mobile-search__bar">
          <button
            type="button"
            className="mobile-header-btn"
            onClick={() => setActiveSearch(false)}
            aria-label="Close search"
          >
            <i className="ph ph-arrow-left" />
          </button>
          <div className="mobile-search__field">
            <i className="ph ph-magnifying-glass" aria-hidden="true" />
            <input
              ref={mobileSearchInputRef}
              type="search"
              name="search"
              placeholder="Search for products"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoComplete="off"
              enterKeyHint="search"
              aria-label="Search for products"
            />
            {searchQuery && (
              <button
                type="button"
                className="mobile-search__clear"
                onClick={() => {
                  setSearchQuery("");
                  mobileSearchInputRef.current?.focus();
                }}
                aria-label="Clear search"
              >
                <i className="ph-fill ph-x-circle" />
              </button>
            )}
          </div>
          <button type="submit" className="mobile-search__submit" aria-label="Search">
            <i className="ph ph-magnifying-glass" />
          </button>
        </div>

        <div className="mobile-search__body">
          {searchQuery.trim() && keywords.some((kw) => kw.resultCount > 0) && (
            <>
              <p className="mobile-search__heading">Popular searches</p>
              <ul className="mobile-search__list">
                {keywords
                  .filter((kw) => kw.resultCount > 0)
                  .map((kw) => (
                    <li key={kw.name}>
                      <button
                        type="button"
                        className="mobile-search__item"
                        onClick={() => {
                          setActiveSearch(false);
                          navigate(`/search?query=${encodeURIComponent(kw.name)}`);
                        }}
                      >
                        <i className="ph ph-magnifying-glass" aria-hidden="true" />
                        <span className="mobile-search__item-text">
                          {highlightMatch(kw.name, searchQuery).map(({ part, match }, index) =>
                            match ? <mark key={index}>{part}</mark> : <span key={index}>{part}</span>
                          )}
                        </span>
                        <span className="mobile-search__count">{kw.resultCount}</span>
                        <i className="ph ph-arrow-up-left mobile-search__fill" aria-hidden="true" />
                      </button>
                    </li>
                  ))}
              </ul>
            </>
          )}
        </div>
      </form>


      <aside
        className={`mobile-menu d-lg-none ${menuActive ? "active" : ""}`}
        aria-hidden={!menuActive}
        aria-label="Menu"
      >
        <div className="mobile-menu__header">
          <Link to="/" className="mobile-menu__logo" onClick={closeDrawers}>
            <img src={Logo} alt="Bigmall" />
          </Link>
          <button
            onClick={closeDrawers}
            type="button"
            className="mobile-menu__close"
            aria-label="Close menu"
          >
            <i className="ph ph-x" />
          </button>
        </div>

        <Link
          to={isAuthenticated ? "/account" : "/login"}
          className="mobile-menu__account"
          onClick={closeDrawers}
        >
          <span className="mobile-menu__avatar">
            <i className="ph ph-user" />
          </span>
          <span className="flex-grow-1 min-w-0">
            <span className="mobile-menu__account-name">
              {isAuthenticated
                ? `Hi, ${user?.displayName ?? user?.username ?? "there"}`
                : "Hello, sign in"}
            </span>
            <span className="mobile-menu__account-hint">
              {isAuthenticated ? "My account" : "Login or create an account"}
            </span>
          </span>
          <i className="ph ph-caret-right text-gray-400" />
        </Link>

        <nav className="mobile-menu__nav">
          <span className="mobile-menu__section-title">Shop</span>
          <NavLink to="/" end className="mobile-menu__link" onClick={closeDrawers}>
            <i className="ph ph-house" /> Home
          </NavLink>
          <NavLink to="/products" className="mobile-menu__link" onClick={closeDrawers}>
            <i className="ph ph-storefront" /> All Products
          </NavLink>
          <button
            type="button"
            className="mobile-menu__link"
            onClick={() => {
              setMenuActive(false);
              setActiveCategory(true);
            }}
          >
            <i className="ph ph-squares-four" /> Categories
            <i className="ph ph-caret-right ms-auto text-gray-400" />
          </button>
          <NavLink to="/hotdeals" className="mobile-menu__link" onClick={closeDrawers}>
            <i className="ph ph-fire" /> Hot Deals
          </NavLink>
          {/* Every active collection from the API, linked by its own type and slug. */}
          {hasCollections &&
            collections
              .filter((collection) => collection.status === "active" && collection.type && collection.slug)
              .map((collection) => (
                <NavLink
                  key={collection.slug}
                  to={`/${collection.type.toLowerCase()}/${collection.slug}`}
                  className="mobile-menu__link"
                  onClick={closeDrawers}
                >
                  <i className="ph ph-tag" /> {collection.displayName}
                </NavLink>
              ))}

          {isAuthenticated && (
            <>
              <span className="mobile-menu__section-title">My account</span>
              <NavLink to="/my-orders" className="mobile-menu__link" onClick={closeDrawers}>
                <i className="ph ph-package" /> My Orders
              </NavLink>
              <NavLink to="/wishlist" className="mobile-menu__link" onClick={closeDrawers}>
                <i className="ph ph-heart" /> Wishlist
              </NavLink>
              <NavLink to="/address-book" className="mobile-menu__link" onClick={closeDrawers}>
                <i className="ph ph-map-pin" /> Address Book
              </NavLink>
            </>
          )}

          <span className="mobile-menu__section-title">Help</span>
          <NavLink to="/track-order" className="mobile-menu__link" onClick={closeDrawers}>
            <i className="ph ph-truck" /> Track Order
          </NavLink>
          <NavLink to="/contact" className="mobile-menu__link" onClick={closeDrawers}>
            <i className="ph ph-chat-circle-dots" /> Contact Us
          </NavLink>
          {isAuthenticated && (
            <>
              <span className="mobile-menu__divider" />
              <button
                type="button"
                className="mobile-menu__link mobile-menu__link--danger"
                onClick={() => {
                  closeDrawers();
                  logout();
                }}
              >
                <i className="ph ph-sign-out" /> Log out
              </button>
            </>
          )}
        </nav>

        <div className="mobile-menu__footer">
          <button
            type="button"
            className="btn btn-outline-main w-100 d-flex align-items-center justify-content-center gap-8"
            onClick={() => {
              closeDrawers();
              handleModalOpen();
            }}
          >
            <i className="ph ph-device-mobile text-xl" /> Get the Bigmall app
          </button>
          <a href="tel:+94777961772" className="mobile-menu__hotline">
            <i className="ph ph-phone-call" /> (+94) 777961772
          </a>
        </div>
      </aside>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      {/* Desktop only: below lg the account name and logout live in the side menu. */}
      <div className="header-top bg-main-600 d-none d-lg-block">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap">
              <li className="border-right-item d-none d-md-block">
                <Link
                  to="/about-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About Us
                </Link>
              </li>

              <li className="border-right-item d-none d-md-block">
                <Link
                  to="/return-policy"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Refund & Returns Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              {isAuthenticated ? (
                <>
                  {/* My Account Link */}
                  <li className="border-right-item">
                    <Link
                      to="/account"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-user-circle" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        <span>{user?.displayName ?? user?.username}</span>
                      </span>
                    </Link>
                  </li>

                  {/* Logout Button */}
                  <li className="border-right-item">
                    <button
                      onClick={logout}
                      className="text-white text-sm py-8 flex-align gap-6 bg-transparent border-0 cursor-pointer"
                    >
                      <span className="icon text-md d-flex">
                        <i className="ph ph-sign-out" />
                      </span>
                      <span className="hover-text-decoration-underline">
                        Logout
                      </span>
                    </button>
                  </li>
                </>
              ) : (
                /* Login Link */
                <li className="border-right-item">
                  <Link
                    to="/login"
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      <i className="ph ph-user-circle" />
                    </span>
                    <span className="hover-text-decoration-underline">
                      Login/Register
                    </span>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start ========================= */}
      <MobileBanner />
      <header
        className={`header-middle bg-color-white border-bottom border-gray-100 d-none d-lg-block
         ${scroll && "fixed-header"}`}
      >
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="max-w-120 ms-16 d-none d-md-block">
              <Link to="/" className="link">
                <img src={Logo} alt="Logo" />
              </Link>
            </div>

            {/* Logo End  */}

            <form
              onSubmit={handleSearchSubmit}
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div
                className="search-category position-relative d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none"
                style={{ display: "block" }}
                ref={containerRef}
              >
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    name="search"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                    placeholder="Search for products"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setShowSuggestions(true);
                    }}
                    onFocus={() => setShowSuggestions(false)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setShowSuggestions(false);
                      }
                    }}
                    autoComplete="off"
                  />
                  <button
                    type="submit"
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                  >
                    {loading ? (
                      <i className="ph ph-spinner animate-spin" />
                    ) : (
                      <i className="ph ph-magnifying-glass" />
                    )}
                  </button>
                </div>
                {showSuggestions && keywords.length > 0 && (
              <div className="suggestions-dropdown position-absolute w-100 bg-white shadow mt-1 rounded">
                <ul className="list-unstyled mb-0">
                  <li className="px-3 py-2 fw-bold text-muted d-flex justify-content-between">
                    <span>Popular Searches</span>
                    <span>Result Count</span>
                  </li>
                 
                  {keywords.filter(kw => kw.resultCount > 0).map((kw) => (
                    <li
                      key={kw.name}
                      className="px-3 py-2 cursor-pointer hover-bg-light d-flex justify-content-between align-items-center"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        
                        setShowSuggestions(false);
                        setActiveSearch(false);
                        navigate(`/search?query=${encodeURIComponent(kw.name)}`);
                      }}
                      onTouchEnd={(e) => {
                        // Add touch handler for mobile
                        e.preventDefault();
                        
                        setShowSuggestions(false);
                        setActiveSearch(false);
                        navigate(`/search?query=${encodeURIComponent(kw.name)}`);
                      }}
                    >
                      <span className="text-muted">
                        {highlightMatch(kw.name, searchQuery).map(({ part, match }, index) =>
                          match ? (
                            <span key={index} style={{ fontWeight: "bold", color: "#ef253c" }}>{part}</span>
                          ) : (
                            <span key={index}>{part}</span>
                          ))}</span>
                      <span className="d-flex align-items-center">
                        <span>({kw.resultCount})</span>
                        <i className="ph ph-arrow-up-right ms-1" />
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          
      </form>


            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  className="btn btn-sm btn-outline-main flex-align align-items-center"
                  onClick={handleModalOpen}
                >
                  <i className="bi bi-phone fs-4 text-main"></i>
                  <span className="ms-2 fw-bold">Get Big Mall App</span>
                </button>
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>
                {/* Show wishlist only if user is authenticated */}
                {isAuthenticated && (
                  <Link to="/wishlist" className="flex-align gap-4 item-hover">
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {wishlistCount}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                )}
                <Link to="/cart" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {cartCount}
                    </span>
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                    Cart
                  </span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      <header className="header bg-white border-bottom border-gray-100">
        <div className="container container-lg">
          <nav
            className="header-inner d-flex justify-content-between gap-8 mt-6"
            style={{ height: "45px" }}
          >
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className="category" ref={categoryMenuRef}>
                {/* Original "All Categories" button (Hidden on mobile) */}
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  aria-expanded={activeCategory}
                  className="category__button flex-align gap-8 fw-medium p-5 border-end border-start border-gray-100 text-heading d-none d-md-flex"
                >
                  <span className="icon text-2xl">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span>All</span> Categories
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>

                {/* New Tile Icon Button (Only Visible on Mobile) */}
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  aria-label="Categories"
                  aria-expanded={activeCategory}
                  className="mobile-header-btn d-flex d-md-none"
                >
                  <i className="ph ph-squares-four" />
                </button>

                <div
                  className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${activeCategory && "active"
                    }`}
                >
                  <div className="mobile-menu__header category-drawer__header d-lg-none">
                    <span className="category-drawer__title">Categories</span>
                    <button
                      onClick={closeDrawers}
                      type="button"
                      className="mobile-menu__close"
                      aria-label="Close categories"
                    >
                      <i className="ph ph-x" />
                    </button>
                  </div>

                  {/* Logo Start */}

                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {categories.map((category, index) => (
                      <li
                        key={category.id}
                        data-category-id={category.id}
                        className={`has-submenus-submenu ${activeIndexCat === index ? "active" : ""
                          }`}
                      >
                        <button
                          type="button"
                          className={`category-drawer__row${category.id === currentCategoryId ? " is-current" : ""}`}
                          aria-expanded={activeIndexCat === index}
                          onClick={() => toggleCategoryRow(index, category.id)}
                        >
                          <CategoryThumb image={category.image} className="category-drawer__thumb" />
                          <span className="category-drawer__name">{category.name}</span>
                          <i className="ph ph-caret-right category-drawer__toggle" aria-hidden="true" />
                        </button>

                        <div
                          className={`submenus-submenu py-16 ${activeIndexCat === index ? "open" : ""
                            }`}
                        >
                          <ul className="submenus-submenu__list category-drawer__subs max-h-300 overflow-y-auto scroll-sm">
                            <li className="category-drawer__all">
                              <Link
                                to={`/products?category=${category.id}`}
                                onClick={closeDrawers}
                                className={category.id === currentCategoryId && !currentSubId ? "is-current" : undefined}
                                aria-current={category.id === currentCategoryId && !currentSubId ? "page" : undefined}
                              >
                                All {category.name}
                                <i className="ph ph-arrow-right" aria-hidden="true" />
                              </Link>
                            </li>
                            {loading && activeIndexCat === index ? (
                              <li className="category-drawer__loading" aria-label="Loading subcategories">
                                <span className="skeleton-line w-120" />
                                <span className="skeleton-line w-200" />
                                <span className="skeleton-line w-120" />
                              </li>
                            ) : subCategories.length > 0 ? (
                              subCategories.map((subCategory) => (
                                <li key={subCategory.id}>
                                  <Link
                                    to={`/products?category=${category.id}&sub=${subCategory.id}`}
                                    onClick={closeDrawers}
                                    className={subCategory.id === currentSubId ? "is-current" : undefined}
                                    aria-current={subCategory.id === currentSubId ? "page" : undefined}
                                  >
                                    {subCategory.name}
                                  </Link>
                                </li>
                              ))
                            ) : (
                              activeIndexCat === index && (
                                <li className="category-drawer__empty">No subcategories</li>
                              )
                            )}
                          </ul>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <Link to="/" className="mobile-header-logo d-lg-none" aria-label="Bigmall home">
                <img src={Logo} alt="Bigmall" />
              </Link>
              {/* Category Dropdown End  */}
              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                {/* Nav Menu Start */}
                <ul className="nav-menu flex-align ">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li>

                  <li className="nav-menu__item">
                    {hasCollections ? (
                      <div className="dropdown">
                        <button
                          type="button"
                          className="nav-menu__link dropdown-toggle bg-transparent border-0"
                          id="productsDropdown"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Products
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="productsDropdown"
                        >
                          {collections
                            .filter(
                              (collection) => collection.status === "active" && collection.type && collection.slug
                            )
                            .map((collection) => {
                              const collectionLink = `/${collection.type.toLowerCase()}/${collection.slug
                                }`;
                              return (
                                <li key={collection.slug}>
                                  <NavLink
                                    to={collectionLink}
                                    className="dropdown-item"
                                  >
                                    {collection.displayName}
                                  </NavLink>
                                </li>
                              );
                            })}

                          <li>
                            <NavLink to="/products" className="dropdown-item">
                              All Products
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <NavLink
                        to="/products"
                        className={({ isActive }) =>
                          isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        Products
                      </NavLink>
                    )}
                  </li>

                  {isAuthenticated ? (
                    <li className="nav-menu__item">
                      <NavLink
                        to="/my-orders"
                        className={(navData) =>
                          navData.isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        My Orders
                      </NavLink>
                    </li>
                  ) : (
                    <li className="nav-menu__item">
                      <NavLink
                        to="/track-order"
                        className={(navData) =>
                          navData.isActive
                            ? "nav-menu__link activePage"
                            : "nav-menu__link"
                        }
                      >
                        Track Order
                      </NavLink>
                    </li>
                  )}

                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                  <li className="on-hover-item nav-menu__item has-submenu">
                    <ul className="submenu">
                      <li className="nav-menu__item">
                        <NavLink
                          to="/hotdeals"
                          className={(navData) =>
                            navData.isActive
                              ? "nav-menu__link activePage"
                              : "nav-menu__link"
                          }
                        >
                          Hot Deals
                        </NavLink>
                      </li>
                    </ul>
                    
                  </li>

                  {/* sample entry starts here */}

                  {PageTypeCollection?.map((page) => (
                    <li
                      key={page.id || page._id || page.displayName}
                      className="on-hover-item nav-menu__item has-submenu"
                    >
                      <ul className="submenu">
                        <li className="nav-menu__item">
                          <NavLink
                            to={
                              page.type && page.slug
                                ? `/${page.type.toLowerCase()}/${page.slug}`
                                : "/page"
                            }
                            className={(navData) =>
                              navData.isActive
                                ? "nav-menu__link activePage"
                                : "nav-menu__link"
                            }
                          >
                            {page.displayName || "No Name"}
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                  ))}
                  
                  {/* sample entry ends here */}

                </ul>
                {/* Nav Menu End */}
              </div>
              {/* Menu End  */}
            </div>
            {/* Header Right start */}
            <div
              className="header-right flex-align"
            >
              <Link
                to="tel:+94777961772"
                className="text-dark p-12 h-100 hover-bg-gray-50 flex-align gap-8 text-lg d-lg-flex d-none hover-text-main"
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                (+94) 777961772
              </Link>
              <div className="mobile-header-actions d-lg-none">
                <button
                  onClick={handleSearchToggle}
                  type="button"
                  className="mobile-header-btn search-icon"
                  aria-label="Search"
                >
                  <i className="ph ph-magnifying-glass" />
                </button>
                {/* Show wishlist only if user is authenticated */}
                {isAuthenticated && (
                  <Link to="/wishlist" className="mobile-header-btn" aria-label={`Wishlist, ${wishlistCount} items`}>
                    <i className="ph ph-heart" />
                    {wishlistCount > 0 && <span className="mobile-header-btn__badge">{wishlistCount}</span>}
                  </Link>
                )}
                <Link to="/cart" className="mobile-header-btn" aria-label={`Cart, ${cartCount} items`}>
                  <i className="ph ph-shopping-cart-simple" />
                  {cartCount > 0 && <span className="mobile-header-btn__badge">{cartCount}</span>}
                </Link>
                <button
                  onClick={handleMenuToggle}
                  type="button"
                  className="mobile-header-btn toggle-mobileMenu"
                  aria-label="Menu"
                >
                  <i className="ph ph-list" />
                </button>
              </div>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
        {/* Mobile Bottom Navigation - Visible Only on Mobile */}
      </header>
      {/* ==================== Header End Here ==================== */}
      <MobileBottomNav />
      {isModalOpen && <AppDownloadModal onClose={handleModalClose} />}
    </>
  );
};

export default Header;
